import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axiosInstance';
import showModal from '../components/ui/modals/showModal';
import { AuthContext } from '../context/AuthContext';

const MicrosoftCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useContext(AuthContext);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const code = query.get('code');

    if (!code) {
      showModal('Brak kodu logowania Microsoft.', { type: 'error' });
      return;
    }

    const loginWithMicrosoft = async () => {
      try {
        const response = await axios.post(
          `https://${process.env.REACT_APP_HOST}/api/auth/microsoft-login`,
          { code }
        );

        const { token, consentGiven } = response.data;

        localStorage.setItem('token', token);

        if (!consentGiven) {
          setTimeout(() => {
            navigate('/consent-required');
          }, 0);
          return;
        }

        // Jeśli zgoda jest wyrażona, pobierz usera i usuń flagę
        const userRes = await axios.get('/api/auth/me');
        setUser(userRes.data);
        navigate('/');
      } catch (error) {
        if (
          error.response?.status === 403 &&
          error.response.data?.reason === 'email_taken_by_classic'
        ) {
          showModal('Dla tego adresu e-mail istnieje konto lokalne. Logowanie przez Microsoft jest niedozwolone.', {
            type: 'error'
          });
          navigate('/login');
          return;
        }
        if (
          error.response?.status === 403 &&
          error.response.data?.requiresConsent
        ) {
          const token = error.response.data?.token;
          if (token) {
            localStorage.setItem('token', token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
          }
          navigate('/consent-required');
          return;
        }

        console.error('Błąd logowania Microsoft:', error);
        showModal('Nie udało się zalogować przez Microsoft.', {
          type: 'error'
        });
      }
    };

    loginWithMicrosoft();
  }, [navigate, setUser]);

  return <p>Logowanie przez Microsoft, proszę czekać...</p>;
};

export default MicrosoftCallback;
